import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Currency } from "../../types/types";

interface DepositInitialState {
  modal: {
    isOpen: boolean;
    currency: Currency;
  };
}

const initialState: DepositInitialState = {
  modal: {
    isOpen: false,
    currency: "ARS",
  },
};

const depositSlice = createSlice({
  name: "deposit",
  initialState,
  reducers: {
    updateModal: (
      state,
      action: PayloadAction<Partial<DepositInitialState["modal"]>>
    ) => {
      state.modal = { ...state.modal, ...action.payload };
    },
    openModal: (state) => {
      state.modal.isOpen = true;
    },
    closeModal: (state) => {
      state.modal.isOpen = false;
    },
  },
});

export const { updateModal, openModal, closeModal } = depositSlice.actions;

export default depositSlice.reducer;
